var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "17zc4coxoa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.784314 0 0 0 0 0.894118 0 0 0 0 0.784314 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#17zc4coxoa)",
    transform: "translate(-875 -92) translate(691 44) translate(184 48)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.958 39.092c.02-.086.032-.175.032-.266V1.252c0-.637-.536-1.174-1.174-1.174H1.174C.536.078 0 .615 0 1.252v13.934c0 .648.526 1.174 1.174 1.174.649 0 1.175-.526 1.175-1.174V3.682l25.159 19.954-25.16 19.087V20.822c0-.649-.525-1.174-1.174-1.174-.648 0-1.174.525-1.174 1.174V51.35c0 .648.526 1.174 1.174 1.174h43.954c.606 9.08 8.186 16.282 17.416 16.282C72.169 68.806 80 60.976 80 51.35c0-4.773-1.926-9.104-5.042-12.258zm-13.873-5.136l-13.603-10.32 25.16-19.954V37.12c-2.853-2.03-6.338-3.225-10.098-3.225-.491 0-.978.021-1.46.062zm9.361-31.53L37.496 28.56 4.543 2.427h65.902zM2.35 50.177V45.67l27.059-20.528 7.358 5.835c.422.335 1.036.335 1.46 0l7.356-5.835 12.352 9.37c-7.032 1.927-12.304 8.152-12.806 15.663H2.348zm60.195 16.282c-8.33 0-15.107-6.778-15.107-15.108 0-8.33 6.777-15.107 15.107-15.107 8.33 0 15.107 6.777 15.107 15.107 0 8.33-6.776 15.108-15.107 15.108z",
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.728 51.35c0-2.318-1.283-4.341-3.176-5.4.422-.599.671-1.328.671-2.115 0-2.028-1.65-3.679-3.68-3.679-2.028 0-3.678 1.65-3.678 3.68 0 .786.249 1.515.671 2.114-1.893 1.059-3.176 3.082-3.176 5.4 0 5.61-2.149 7.924-2.16 7.937-.725.725-.194 2.005.83 2.005h15.029c1.017 0 1.568-1.267.84-1.996-.023-.022-2.171-2.336-2.171-7.946zm-7.515-7.515c0-.733.597-1.33 1.33-1.33.735 0 1.332.597 1.332 1.33 0 .734-.597 1.331-1.331 1.331s-1.33-.597-1.33-1.33zM57.17 58.943c.749-1.536 1.538-4.006 1.538-7.593 0-2.115 1.721-3.835 3.836-3.835 2.115 0 3.835 1.72 3.835 3.835 0 3.587.79 6.057 1.54 7.593H57.17z",
    transform: "translate(0 7)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/ic-notification.417e8bc790e389db988a9eccf87722de.svg";
export { ForwardRef as ReactComponent };